import type { Router } from 'vue-router'
import { ref, watch } from 'vue'

const pageLoadedMap: Record<string, boolean> = {}

/**
 * 页面第一次loading状态
 */
function useRouteLoadingHook(router: Router) {
  const isLoading = ref(false)
  let loadingName: string

  router.beforeEach((to) => {
    const routeName = to.name as string
    if (!pageLoadedMap[routeName]) {
      loadingName = routeName
      isLoading.value = true
    } else {
      loadingName = ''
    }
  })

  router.afterEach((to) => {
    const routeName = to.name as string
    pageLoadedMap[routeName] = true

    if (!loadingName || routeName === loadingName) {
      isLoading.value = false
    }
  })

  return { isLoading }
}

/**
 * loading显示逻辑(是否显示/百分比)
 */
export function usePageLoading(router: Router) {
  const { isLoading } = useRouteLoadingHook(router)
  const isShowPageLoading = ref(false)
  const percent = ref(0)
  let timeId: number, intervalId: number

  watch(isLoading, (val) => {
    isShowPageLoading.value = true
    clearInterval(intervalId)
    if (val) {
      percent.value = 10
      intervalId = setInterval(() => {
        percent.value += 15
        if (percent.value > 80) clearInterval(intervalId)
      }, 300)
    } else {
      percent.value = 100
      clearTimeout(timeId)
      timeId = setTimeout(() => {
        isShowPageLoading.value = false
      }, 500)
    }
  })

  return { isShowPageLoading, percent }
}
